export const validatePhoneNumber = (value) =>
    /^\+(93|355|213|376|244|672|54|374|297|61|43|994|973|880|375|32|501|229|975|591|387|267|55|246|673|359|226|257|855|237|1|238|236|235|56|86|61|61|57|269|682|506|385|53|599|357|420|243|45|253|670|593|20|503|240|291|372|251|500|298|679|358|33|689|241|220|995|49|233|350|30|299|502|44-1481|224|245|592|509|504|852|36|354|91|62|98|964|353|44-1624|972|39|225|81|44-1534|962|7|254|686|383|965|996|856|371|961|266|231|218|423|370|352|853|389|261|265|60|960|223|356|692|222|230|262|52|691|373|377|976|382|212|258|95|264|674|977|31|599|687|64|505|227|234|683|850|47|968|92|680|970|507|675|595|51|63|64|48|351|974|242|262|40|7|250|590|290|590|508|685|378|239|966|221|381|248|232|65|421|386|677|252|27|82|211|34|94|249|597|47|268|46|41|963|886|992|255|66|228|690|676|216|90|993|688|256|380|971|44|1|598|998|678|379|58|84|681|212|967|260|263)[0-9]{1,14}$/.test(
        value,
    ) // ^\+[1-9]\d{1,14}$ E.164 international standard not specific enough

export const validateNumber = (value) => {
    return {
        vatNumber: value && /^([A-Z]{2})([0-9A-Za-z+*.]{2,12})$/.test(value),
    }
}

export const validateVatNumber = (value, countryCode) => {
    const regexes = {
        IT: /^IT[A-Za-z0-9]{11}$/,
        ES: /^ES[A-Za-z0-9]{9}$/,
        FR: /^FR[A-Za-z0-9]{11}$/,
        BE: /^BE[A-Za-z0-9]{10}$/,
        PL: /^PL[A-Za-z0-9]{10}$/,
        DE: /^DE[A-Za-z0-9]{9}$/,
        MY: /^[A-Za-z][0-9]{10,12}$/,
    }
    let vatNumber = true
    if (countryCode && regexes[countryCode]) {
        vatNumber = regexes[countryCode].test(value)
    } else {
        vatNumber = value && /^([A-Z]{2})([0-9A-Za-z+*.]{2,12})$/.test(value)
    }
    return {vatNumber}
}
